import React from 'react';
import './pipeline.css';
import CodeEditor from '../codeeditor';
import DepedencyGraph from '../depgraph';
import Scheduler from './scheduler';
import pipelineModels from './pipelinemodels';
import Diagram from './diagram';
import StringSelect from '../stringselect';
import { Icon, Button } from '@blueprintjs/core';
import codeManager from '../codemanager';
import SolutionPanel from '../solutionpanel';

export default class Pipeline extends React.Component {

    constructor(props) {
        super(props);
        this.state = {  
                        code: "",
                        instrList: null,
                        pipelineModel: "Egyszerű, 5 fokozatú",
                    };
        this.handleNewCode = this.handleNewCode.bind(this);
    }

    componentDidMount() {
        this.handleNewCode();
    }

    handleNewCode() {
        const code = codeManager.getRandomCode(pipelineModels[this.state.pipelineModel]);
        this.setState({code: code, instrList: codeManager.parseCode(code)});
    }

    render() {

        let error = <></>;
        if (this.state.instrList && this.state.instrList.some(x => x.error.length > 0)) {
            error = <div className="code-error-area">
                {this.state.instrList.filter(x => x.error.length > 0).map((instr, ix) =>
                    <div key={ix}><Icon icon="error"/>&nbsp;{`line ${instr.line}: ${instr.error}`}</div>)}
            </div>
        }


        return (
            <>
                <div className="title-area">
                    <h1>Utasítás pipeline</h1>
                    <h2>Futószalag elvű utasítás-feldolgozás</h2>
                </div>
                <div className="demo-emph-row">
                    <div className="pipeline-top-row-left-col">
                        <h3>Utasítássorozat:</h3>
                        <CodeEditor 
                            code={this.state.code} 
                            onChange={instrList => this.setState({instrList: instrList})} 
                        />
                        <Button 
                            icon="refresh"
                            text="Másik generálása"
                            className="pipeline-generate-button"
                            onClick={this.handleNewCode} 
                        />
                    </div>
                    <div className="pipeline-top-row-right-col">
                        <div className="pipeline-title-row">
                            <h3>Pipeline:</h3>
                            <StringSelect 
                                items={Object.keys(pipelineModels)}
                                initial={this.state.pipelineModel}
                                onChange={val => this.setState({pipelineModel: val})} 
                            />
                        </div>
                        <div className="pipeline-diagram-area">
                            <Diagram pipelineModel={pipelineModels[this.state.pipelineModel]} />
                        </div>
                    </div>
                </div>
                {error}
                <div>
                    {this.state.pipelineModel && <p className="pipeline-description">{pipelineModels[this.state.pipelineModel].description}</p>}
                </div>
                <div>
                    <h3>1. Feladat</h3>
                    <p>Rajzolja fel az utasítások percedenciagráfját! Az éleket cimkézze fel az egymásrahatások típusának 
                        megfelelően (RAW/WAR/WAW)! Ha két utasítás között több egymásrahatás is van, tüntesse fel mindet!</p>
                </div>
                <div>
                    <SolutionPanel title="Megoldás mutatása">
                        <div className="demo-emph-row">
                            <DepedencyGraph instrList={this.state.instrList} />
                        </div>
                    </SolutionPanel>
                </div>
                <div>
                    <h3>2. Feladat</h3>
                    <p>Adja meg az utasítássorozat ütemezését (melyik utasítás mikor melyik fázisban van)! 
                        Ha az utasítást a következő ciklusban nem lehet továbbítani, jelezze, hogy mi az oka! Használja az alábbi jelöléseket:</p>
                        <ul>
                            <li>RAW/WAR/WAR, ha a szünet oka adategymásrahatás, zárójelben adja meg, melyik regiszter az oka,</li>
                            <li>Feld., ha a szünet oka feldolgozási egymásrahatás,</li>
                            <li>Proc., ha a szünet oka procedurális egymásrahatás.</li>
                        </ul>
                        <p>Az utasítás betöltése előtti ciklusokban nem szükséges jelölni a feldolgozási egymásrahatást, 
                        de a procedurálist igen.
                    </p>
                    <p>Minden egyes utasításnál jelölje, hogy szükség van-e a végrehajtásához forwarding-ra! Ha igen, 
                        adja meg, hogy melyik pipeline regiszterből kell a szükséges értéket visszacsatolni! A pipeline
                        regisztereket jelölje a fenti ábrán megadott módon!
                    </p>
                </div>
                <div>
                    <SolutionPanel title="Megoldás mutatása">
                        <div className="demo-emph-row">
                            <Scheduler 
                                instrList={this.state.instrList}
                                pipelineModel={pipelineModels[this.state.pipelineModel]} 
                            />
                        </div>
                    </SolutionPanel>
                </div>
            </>
        );
    }
}